var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbarDistance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_1",
    "data-name": "Component 7 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 32.466,
    viewBox: "0 0 37 32.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, -101.394, -217.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(198.168 -189.665)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(202.638 -173.125)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 3.903,
    y2: 15.672,
    transform: "translate(201.58 -186.418)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(-431 -38.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M2.5,0,5,9H0Z",
    transform: "translate(433 38.37)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M3.5,0,7,12H0Z",
    transform: "translate(432 41.37)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M4.5,0,9,12H0Z",
    transform: "translate(431 47.37)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 3,
    height: 6,
    transform: "translate(434 59.37)",
    fill: "current"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(-403 -38.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M2.5,0,5,9H0Z",
    transform: "translate(433 38.37)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-2",
    "data-name": "Polygon 2",
    d: "M3.5,0,7,12H0Z",
    transform: "translate(432 41.37)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    d: "M4.5,0,9,12H0Z",
    transform: "translate(431 47.37)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577-2",
    "data-name": "Rectangle 577",
    width: 3,
    height: 6,
    transform: "translate(434 59.37)",
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarDistance);
export default __webpack_public_path__ + "static/media/toolbar-distance.f442035b40314596faf4ed820ba74de8.svg";
export { ForwardRef as ReactComponent };